import { MouseEvent, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';

import useTracking from '../../core/hooks/useTracking';
import { ILink } from '../../core/models/link';
import { Icon } from '../Icon/Icon';

interface IProps {
  link: ILink;
  className?: string;
  onClick?(e: React.MouseEvent<HTMLElement>): void;
}

function CustomLink({ link, className, onClick }: IProps) {
  const btnRef = useRef<HTMLAnchorElement>(null);
  const { trackEvent } = useTracking();

  const handleClick = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      trackEvent({
        name: 'link_click',
        properties: { link_id: link.id, link_href: link.href },
      });
      if (!onClick) return;
      onClick(e);
    },
    [trackEvent, link.id, link.href, onClick],
  );

  return !link.text ? null : link.refreshPage ? (
    <a
      className={`${className ? `${className} ` : ''}${link.color === 'light' ? ` btn` : link.color === 'link' ? ' link' : ''}`}
      href={link.href}
      onClick={handleClick}
      target={link.newTab ? '_blank' : ''}
      rel={link.newTab ? 'noreferrer nofollow' : ''}
      download={link.isDownload}
      id={link.id || ''}
      ref={btnRef}
    >
      {link.text}
      {!link.showArrow ? null : <Icon.Arrow className="icon" />}
      {!link.isDownload ? null : <Icon.External className="icon" />}
    </a>
  ) : (
    <Link
      className={`${className ? `${className}` : ''}${link.color === 'light' ? ` btn` : link.color === 'link' ? ' link' : ''}`}
      to={link.href}
      onClick={handleClick}
      target={link.newTab ? '_blank' : ''}
      rel={link.newTab ? 'noreferrer nofollow' : ''}
      download={link.isDownload}
      id={link.id || ''}
      ref={btnRef}
    >
      {link.text}
      {!link.showArrow ? null : <Icon.Arrow className="icon" />}
      {!link.isDownload ? null : <Icon.External className="icon" />}
    </Link>
  );
}

export default CustomLink;
